export default "__VITE_ASSET__BAE4IO5V__"